import { createFileRoute } from '@tanstack/react-router'
import { PlaygroundReportPane } from './-components/dev/transition-playground'

// The report pager's FIRST member — its leading edge is where the pager hands a back-swipe to the stack.
export const Route = createFileRoute('/_app/dev-resources/transitions/jobs/$jobId/report')({
  component: () => <PlaygroundReportPane title="Competencies" rows={18} />,
})
